export default __webpack_public_path__ + "static/media/image2.6a0f4b3f.jpg";